import { ValueSetterParams } from '@ag-grid-community/core';

(function () {
    'use strict';

    const module = angular.module('imApp');

    module.component('work', {
        templateUrl: 'views/components/views/work/work.template.html?v=' + module.version,
        controllerAs: 'vm',
        controller: ['$stateParams', 'stateService', 'utilityService', 'modalService', 'translateService', 'workService', 'equipmentEditService', 'operationFactoryService', 'logisticService', 'operationService', 'labourPositionService', 'ttGridFactory', function ($stateParams, stateService, utilityService, modalService, translateService, workService, equipmentEditService, operationFactoryService, logisticService, operationService, labourPositionService, ttGridFactory) {

            // #region VARIABLES & DEFINITIONS

            const vm = this;
            let prodId = $stateParams.prod_id;
            let workKeyno = $stateParams.work_keyno;
            let variableName = 'w_work';

            let translations = {
                confirm_title: '',
                confirm_message: '',
                confirm_ok_label: '',
                confirm_cancel_label: '',
                error: '',
                ok: ''
            };

            vm.model = {
                gridReady: false,
                workKeyno: workKeyno,
                factoryButtons: [
                    { id: 'list', icon: 'fa fa-bars', color: 'primary', type: 'primary', onClick: () => stateService.go('factories') },
                    { id: 'goto', icon: 'fa fa-chevron-right', color: 'primary', type: 'primary', onClick: () => stateService.go('factorymenu', { factory_id: vm.model.edit.factory_id }) }
                ],
                operationButtons: [
                    { id: 'list', icon: 'fa fa-bars', color: 'primary', type: 'primary', onClick: () => stateService.go('operations') }
                ],
                operationEditButtons: [
                    { id: 'list', icon: 'fa fa-bars', color: 'primary', type: 'primary', onClick: () => stateService.go('operations') },
                    { id: 'goto', icon: 'fa fa-chevron-right', color: 'primary', type: 'primary', onClick: () => stateService.go('operationmenu', { operation_id: vm.model.edit.operation_id }) }
                ],
                workGroupButtons: [
                    { id: 'erase', icon: 'fa fa-eraser', color: 'danger', type: 'danger', onClick: () => vm.model.edit.workgrp_keyno = '0' },
                    { id: 'list', icon: 'fa fa-bars', color: 'primary', type: 'primary', onClick: () => stateService.go('workgrps') }
                ],
                workGroupEditButtons: [
                    { id: 'erase', icon: 'fa fa-eraser', color: 'danger', type: 'danger', onClick: () => vm.model.edit.workgrp_keyno = '0' },
                    { id: 'list', icon: 'fa fa-bars', color: 'primary', type: 'primary', onClick: () => stateService.go('workgrps') },
                    { id: 'goto', icon: 'fa fa-chevron-right', color: 'primary', type: 'primary', onClick: () => stateService.go('workgrpmenu', { workgrp_keyno: vm.model.edit.workgrp_keyno }) }
                ],
                equipmentButtons: [
                    { id: 'list', icon: 'fa fa-bars', color: 'primary', type: 'primary', onClick: () => stateService.go('equipments') }
                ],
                equipmentEditButtons: [
                    { id: 'erase', icon: 'fa fa-eraser', color: 'danger', type: 'danger', onClick: () => vm.model.edit.equipment_id = '' },
                    { id: 'list', icon: 'fa fa-bars', color: 'primary', type: 'primary', onClick: () => stateService.go('equipments') },
                    { id: 'goto', icon: 'fa fa-chevron-right', color: 'primary', type: 'primary', onClick: () => stateService.go('equipmentedit', { equipment_id: vm.model.edit.equipment_id }) }
                ],
                unitButtons: [
                    { id: 'list', icon: 'fa fa-bars', color: 'primary', type: 'primary', onClick: () => stateService.go('units') }
                ],
                unitEditButtons: [
                    { id: 'list', icon: 'fa fa-bars', color: 'primary', type: 'primary', onClick: () => stateService.go('units') },
                    { id: 'goto', icon: 'fa fa-chevron-right', color: 'primary', type: 'primary', onClick: () => stateService.go('unit', { unit_no: vm.model.edit.unit_no }) }
                ],
                edit: {},
                selectListFactories: [],
                selectListOperations: [],
                selectListWorkGroups: [],
                selectListEquipments: [],
                selectListUnits: [],
                selectListLinkTypes: [],
                lockedSave: false,
                lockedDelete: false
            };

            vm.grid = new ttGridFactory({
                rememberId: '',
                kendo: {
                    height: null,
                    sortable: true,
                    aggregate: true,
                    pager: false,
                    selectable: false,
                    filterable: false
                }
            }).setConfig({
                onDataChanged: (changed, e) => {
                    if (Object.hasOwn(changed, 'colDef')) {
                        onDataChangedAgGrid(changed);
                    } else {
                        onDataChangedKendo(changed, e);
                    }
                }
            });
            
            function onDataChangedKendo(changed, e) {
                let defaultQuantity = 0.00000;
                let timeAdjustFactor = 0.00;

                if (e.values.hasOwnProperty('quantity')) {
                    defaultQuantity = e.values.quantity;
                    timeAdjustFactor = e.model.time_adjust_factor;
                }

                if (e.values.hasOwnProperty('time_adjust_factor')) {
                    defaultQuantity = e.model.quantity;
                    timeAdjustFactor = e.values.time_adjust_factor;
                }

                if (e.values.hasOwnProperty('quantity') || e.values.hasOwnProperty('time_adjust_factor')) {
                    e.model.quantity_multiplied_by_std_time = (defaultQuantity * e.model.std_time);
                    e.model.quantity_in_work_units = (defaultQuantity * e.model.std_time_in_work_units);
                    e.model.adjusted_quantity_in_work_units = (e.model.quantity_in_work_units * timeAdjustFactor);
                    e.model.dirtyFields.quantity_multiplied_by_std_time = true;
                    e.model.dirtyFields.quantity_in_work_units = true;

                    const grid = vm.grid.gridfunc.getGrid();
                    const data = grid.dataSource.data();
                    let total = 0;

                    data.forEach((item) => {
                        total += parseFloat(item.quantity_in_work_units);
                    });

                    total = total.toFixed(4);

                    grid.columns.forEach((col) => {
                        if (col.field === 'quantity_in_work_units') {
                            col.footerTemplate = '<div style=\"text-align: right; font-size: 12px;\">' + total + '</div>';
                        }
                    });

                    total = 0;

                    data.forEach((item) => {
                        total += parseFloat(item.adjusted_quantity_in_work_units);
                    });

                    total = total.toFixed(5);

                    grid.columns.forEach((col) => {
                        if (col.field === 'adjusted_quantity_in_work_units') {
                            col.footerTemplate = '<div style=\"text-align: right; font-size: 12px;\">' + total + '</div>';
                        }
                    });

                    // calling setOptions to force rerender.
                    grid.setOptions({ columns: grid.columns });
                }
            }

            /**
             *
             * 
             * @param {ValueSetterParams} event
             */
            function onDataChangedAgGrid(event) {
                let defaultQuantity = 0.00000;
                let timeAdjustFactor = 0.00;

                if (event.column.colId === 'quantity') {
                    defaultQuantity = event.newValue;
                    timeAdjustFactor = event.data.time_adjust_factor;
                }

                if (event.column.colId === 'time_adjust_factor') {
                    defaultQuantity = event.data.quantity;
                    timeAdjustFactor = event.newValue;
                }

                if (event.data.hasOwnProperty('quantity') || event.data.hasOwnProperty('time_adjust_factor')) {
                    event.data.quantity_multiplied_by_std_time = (defaultQuantity * event.data.std_time);
                    event.data.quantity_in_work_units = (defaultQuantity * event.data.std_time_in_work_units);
                    event.data.adjusted_quantity_in_work_units = (event.data.quantity_in_work_units * timeAdjustFactor);

                    vm.grid.gridfunc.updateRow({ ...event.data, _dirty: true });
                    vm.grid.gridfunc.refreshAggregates();
                }
            }

            // #endregion VARIABLES & DEFINITIONS

            // #region TRANSLATION FUNCTION

            async function translate() {
                let data = await translateService.translateBatch(translations);

                Object.keys(translations).forEach((key) => {
                    if (data?.[key]) translations[key] = data[key];
                });
            }

            // #endregion TRANSLATION FUNCTION

            // #region LOAD PROCEDURE CALLS

            async function loadEdit() {
                vm.model.edit = (await workService.getEdit({
                    prod_id: prodId,
                    work_keyno: workKeyno
                }))[0];
            }

            async function loadLinkTypes() {
                vm.model.selectListLinkTypes = await workService.listLinkTypes();
            }

            async function loadUnits() {
                vm.model.selectListUnits = await logisticService.listUnits({
                    onlytimeunits: '1',
                    isactive: '1'
                });
            }

            async function loadOperations() {
                if (utilityService.validateParmsValue(vm.model.edit.factory_id) !== true) return;

                return vm.model.selectListOperations = await workService.listOperations({
                    direct: '1',
                    factory_id: vm.model.edit.factory_id
                });
            }

            async function loadFactories() {
                if (utilityService.validateParmsValue(vm.model.edit.businessco_no) !== true) return;

                return vm.model.selectListFactories = await labourPositionService.listSelectFactories({ businessco_no: vm.model.edit.businessco_no });
            }

            async function loadWorkGroups() {
                if (utilityService.validateParmsValue(vm.model.edit.workgrp_keyno, true) !== true) return;
                if (utilityService.validateParmsValue(vm.model.edit.operation_id, true) !== true) return;
                if (utilityService.validateParmsValue(vm.model.edit.factory_id) !== true) return;

                return vm.model.selectListWorkGroups = await equipmentEditService.listSelectWorkGroups({
                    workgrp_keyno: vm.model.edit.workgrp_keyno,
                    operation_id: vm.model.edit.operation_id,
                    factory_id: vm.model.edit.factory_id
                });
            }

            async function loadEquipents() {
                if (utilityService.validateParmsValue(vm.model.edit.workgrp_keyno, true) !== true) return;
                if (utilityService.validateParmsValue(vm.model.edit.operation_id, true) !== true) return;
                if (utilityService.validateParmsValue(vm.model.edit.factory_id) !== true) return;

                return vm.model.selectListEquipments = await operationFactoryService.listSelectEquipments({
                    workgrp_keyno: vm.model.edit.workgrp_keyno,
                    operation_id: vm.model.edit.operation_id,
                    factory_id: vm.model.edit.factory_id
                });
            }

            async function retrieveOperation() {
                if (utilityService.validateParmsValue(vm.model.edit.operation_id) !== true) return;

                const response = (await operationService.getOperation({ operation_id: vm.model.edit.operation_id }))[0];

                vm.model.edit.unit_no = response?.unit_no;
                vm.model.edit.adjustment_unit_name = response?.adjustment_unit_name;
            }

            async function modifyOperation() {
                if (utilityService.validateParmsValue(vm.model.edit.factory_id, true) !== true) return;
                if (utilityService.validateParmsValue(vm.model.edit.operation_id, true) !== true) return;

                const response = (await workService.changeOperation({
                    factory_id: vm.model.edit.factory_id,
                    operation_id: vm.model.edit.operation_id
                }))[0];

                vm.model.edit.workgrp_keyno = response?.workgrp_keyno;
                vm.model.edit.equipment_id = response?.equipment_id;
            }

            // #endregion LOAD PROCEDURE CALLS

            // #region GRID PROCEDURE FUNCTION CALLS

            async function loadGrid() {
                if (utilityService.validateParmsValue(vm.model.edit.view_id) === true) {
                    vm.grid.dataTask.rememberId = vm.model.edit.view_id;
                }

                if (utilityService.validateParmsValue(vm.model.edit.p2_datatask_keyno) === true) {
                    vm.grid.dataTask.loadData = {
                        method: vm.model.edit.p2_datatask_keyno,
                        parameters: vm.model.edit
                    };

                    vm.model.gridReady = true;

                    if (vm.grid.gridfunc !== null) vm.grid.gridfunc.read();
                }
            }

            // #endregion GRID PROCEDURE FUNCTION CALLS

            // #region REMEMBER VALUE PROCEDURE FUNCTIONS

            function rememberFunc(value) {
                workService.remember(variableName, value);
            }

            // #endregion REMEMBER VALUE PROCEDURE FUNCTIONS

            // #region BUTTON SAVE PROCEDURE FUNCTION CALL

            vm.saveChanges = function () {
                vm.model.lockedSave = true;
                let mergeObj = vm.model.edit;

                mergeObj.records = vm.grid.gridfunc.getAllRows().map(function (a) {
                    return {
                        "suboperation_keyno": a.suboperation_keyno,
                        "quantity": a.quantity,
                        "quantity_in_work_units": a.quantity_in_work_units,
                        "time_adjust_factor": a.time_adjust_factor,
                        "adjusted_quantity_in_work_units": a.adjusted_quantity_in_work_units
                    };
                });

                workService.saveObj(mergeObj).then(function (response) {
                    if (response[0].errorcode !== '0') {
                        modalService.show({
                            type: 'warning',
                            title: translations.error,
                            message: response[0].errormessage,
                            buttons: [{
                                label: translations.ok,
                                cssClass: 'btn-warning',
                                action: function (dialogItself) {
                                    dialogItself.close();
                                    vm.model.lockedSave = false;
                                }
                            }]
                        });
                    } else {
                        vm.model.lockedSave = false;
                        stateService.back();
                    }
                });
            }

            // #endregion BUTTON SAVE PROCEDURE FUNCTION CALL

            // #region BUTTON DELETE PROCEDURE FUNCTION CALL

            vm.deleteValues = function () {
                vm.model.lockedDelete = true;

                modalService.confirm({
                    type: 'danger',
                    title: translations.confirm_title,
                    message: translations.confirm_message,
                    okLabel: translations.confirm_ok_label,
                    cancelLabel: translations.confirm_cancel_label
                }).then(function () {
                    workService.deleteItem({ work_keyno: vm.model.edit.work_keyno }).then(function (response) {
                        if (response[0].errorcode !== '0') {
                            modalService.show({
                                type: 'warning',
                                title: translations.error,
                                message: response[0].errormessage,
                                buttons: [{
                                    label: translations.ok,
                                    cssClass: 'btn-warning',
                                    action: function (dialogItself) {
                                        dialogItself.close();
                                        vm.model.lockedDelete = false;
                                    }
                                }]
                            });
                        } else {
                            vm.model.lockedDelete = false;
                            stateService.back();
                        }
                    }, function () {
                        vm.model.lockedDelete = false;
                    });
                }, function () {
                    vm.model.lockedDelete = false;
                });
            }

            // #endregion BUTTON DELETE PROCEDURE FUNCTION CALL

            // #region FIELD CHANGE MULTI FUNCTIONS

            vm.onChanged = async function (value, id) {
                switch (id) {
                    case 'factory_id':
                        if (utilityService.validateWatchValue(value, vm.model.edit.factory_id) !== true) return;

                        vm.model.edit.factory_id = value;

                        if (utilityService.validateParmsValue(vm.model.edit.factory_id) !== true) return;

                        await rememberFunc(vm.model.edit.factory_id);
                        loadWorkGroups();
                        loadEquipents();
                        loadOperations();
                        break;
                    case 'operation_id':
                        if (utilityService.validateWatchValue(value, vm.model.edit.operation_id) !== true) return;

                        vm.model.edit.operation_id = value;

                        if (utilityService.validateParmsValue(vm.model.edit.operation_id) !== true) return;

                        retrieveOperation();
                        modifyOperation();
                        loadWorkGroups();
                        loadEquipents();
                        loadGrid();
                        break;
                    case 'workgrp_keyno':
                        if (utilityService.validateWatchValue(value, vm.model.edit.workgrp_keyno) !== true) return;

                        vm.model.edit.workgrp_keyno = value;

                        if (utilityService.validateParmsValue(vm.model.edit.workgrp_keyno) !== true) return;

                        loadEquipents();
                        break;
                    default:
                        utilityService.setValueToVariable(value);
                        break;
                }
            };

            // #endregion FIELD CHANGE MULTI FUNCTIONS

            // #region ON INIT FUNCTION

            vm.$onInit = async function () {
                translate();
                await loadEdit();
                loadLinkTypes();
                loadUnits();
                loadFactories();
                loadGrid();

                if (vm.model.edit.work_keyno === '0') {
                    workService.getRemember(variableName).then(function (value) {
                        if (angular.isDefined(value) && angular.isDefined(value[0]) && angular.isDefined(value[0].variablevalue) && value[0].variablevalue !== null && value[0].variablevalue !== '') {
                            vm.model.edit.factory_id = angular.fromJson(value[0].variablevalue);

                            loadOperations();
                            loadWorkGroups();
                            loadEquipents();
                        }
                    });
                } else {
                    loadOperations();
                    loadWorkGroups();
                    loadEquipents();
                }
            }

            // #endregion ON INIT FUNCTION

        }]
    });
})();
